export default "__VITE_ASSET__D$le1Xk2__"